import React from 'react';
import '../CampanaInfo/CampanaInfo.css';
import parse from 'html-react-parser';
const Opcion4 = (props) => {
  const {
         disponible,
         estado,
         askForKnow,
         nombre,
         descripcion,
         pregunta1,
         idCandidato1,
         Opcion1,
         id
       } = props;



  return (
    <li className="cards_item" key={id}>
      <div className="card" style={{ backgroundImage: "url(/fondos/Fondo5.jpg)" }}>
        <h2 className="card_title">{nombre}</h2>
        <div className="card_text">
          {parse(descripcion)}
        </div>
        <center>
          <button
            disabled={estado === "Allow" && disponible > 0 ? "" : "disabled"}
            className={estado === "Allow" && disponible > 0 ? "button-candidate button-candidate-double" : "button-candidate-disabled button-candidate-double"}
            onClick={e => askForKnow(idCandidato1, e)}
          >
            Si
          </button>
        </center>
      </div>
    </li>
  );
};

export default Opcion4;
